import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
import { zfclightbox } from "./zfc_lightbox";
import { Swiper, Navigation, Pagination, A11y } from "./swiper-config";
export class zfcgac {
    static initSlick(slider, clone, txtMediaGallery) {
        try {
            var dotNav = slider.parent().parent().find(".zfcgac-dot-navigation");
            zfcgac.useSwiper = slider.hasClass("swiper");
            slider
                .find(".swiper-wrapper")
                .children(":not(.swiper-slide)")
                .addClass("swiper-slide");
            var totalSlides = slider.find(".swiper-slide").length;
            var desktopDisplayArrowsDots = totalSlides > slider.data("slide-count") && totalSlides > 1
                ? true
                : false;
            var mobileArrows = false;
            var mobileDots = txtMediaGallery ? false : slider.children().length > 1;
            if (zfcgac.useSwiper && !slider.hasClass(".swiper-initialized")) {
                const swiper = new Swiper("#" + slider.attr("id"), {
                    modules: [Navigation, Pagination, A11y],
                    spaceBetween: 24,
                    loop: false,
                    slidesPerGroup: 1,
                    normalizeSlideIndex: true,
                    preventClicks: false,
                    preventClicksPropagation: false,
                    noSwipingSelector: '.playkit-control-button',
                    breakpoints: {
                        1024: {
                            slidesPerView: slider.data("slide-count") || 4,
                            navigation: {
                                enabled: desktopDisplayArrowsDots,
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                            pagination: {
                                enabled: window.location.href.indexOf("customers.zf.com") > 0
                                    ? slider.find(".zfcgac-item").length > 4
                                    : desktopDisplayArrowsDots,
                                el: ".swiper-pagination",
                                type: "custom",
                                clickable: true,
                                renderCustom: function (swiper, current, total) {
                                    var out = "";
                                    for (var i = 1; i < total + 1; i++) {
                                        if (i == current) {
                                            out =
                                                out +
                                                    '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></button>';
                                        }
                                        else {
                                            out =
                                                out +
                                                    '<button class="swiper-pagination-bullet" tabindex= role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></button>';
                                        }
                                    }
                                    return out;
                                },
                            },
                        },
                        720: {
                            slidesPerView: txtMediaGallery || slider.closest(".zfcgac-slider").length
                                ? 1
                                : 2,
                            navigation: {
                                enabled: desktopDisplayArrowsDots,
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                            pagination: {
                                enabled: desktopDisplayArrowsDots,
                                el: ".swiper-pagination",
                                type: "custom",
                                clickable: true,
                                renderCustom: function (swiper, current, total) {
                                    var out = "";
                                    for (var i = 1; i < total + 1; i++) {
                                        if (i == current) {
                                            out =
                                                out +
                                                    '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></button>';
                                        }
                                        else {
                                            out =
                                                out +
                                                    '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></button>';
                                        }
                                    }
                                    return out;
                                },
                            },
                        },
                        0: {
                            slidesPerView: 1,
                            navigation: {
                                enabled: mobileArrows,
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev",
                            },
                            pagination: {
                                enabled: true,
                                el: '.swiper-pagination',
                                clickable: false,
                                dynamicBullets: true,
                                dynamicMainBullets: 1
                            },
                        },
                    },
                    a11y: {
                        enabled: true,
                        nextSlideMessage: "Next slide",
                        prevSlideMessage: "Previous slide",
                        paginationBulletMessage: "Jump to slide {{index}}",
                        slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                        slideRole: "group",
                        itemRoleDescriptionMessage: "slide",
                    },
                });
                return swiper;
            }
            else {
                if (clone) {
                    zfc.keyboardEnterToClick($(".zfc-lightbox-overlay-close"));
                    $(".zfc-lightbox-overlay-close").click(function () {
                        zfclightbox.lightboxTouched = true;
                    });
                    slider.on("afterChange", function (slick, slide) {
                        if (slider.find("iframe") && zfclightbox.lightboxTouched) {
                            slider.find("iframe").attr("src", $("iframe")
                                .attr("src")
                                .replace(/&autoplay=1/, ""));
                        }
                        zfclightbox.lightboxTouched = true;
                    });
                }
            }
        }
        catch (err) {
            console.log("Initalization failed: zfcgac.initSlick() " + err.message);
        }
    }
    static initItem(item) {
        try {
            var id = item.find(".zfcgac-gallery-item-wrapper").attr("id");
            item.find("img[data-src]").each(function () {
                $(this).attr("src", $(this).data("src"));
            });
            if (item.hasClass("zfcgac-gallery-teaser") &&
                item.find(".zfcgac-gallery-teaser-mobile").length == 0) {
                item.find(".zfcgac-show-page").append(item
                    .find(".zfcgac-gallery-item-wrapper")
                    .clone()
                    .addClass("zfcgac-gallery-teaser-mobile")
                    .attr("id", id + "_mobile"));
            }
            if (item.hasClass("zfcgac-gallery-teaser") &&
                item.data("custom-mobile-swipe") != undefined) {
                item.addClass("zfcgac-gallery-teaser-swipe");
            }
            else if (item.hasClass("zfcgac-gallery-teaser")) {
                zfcgac.useSwiper
                    ? item
                        .find(".zfcgac-gallery-teaser-mobile")
                    : item
                        .find(".zfcgac-gallery-teaser-mobile")
                        .addClass("slick-initialized");
            }
            item.find(".zfcgac-gallery-item-wrapper").each(function () {
                var that = $(this);
                if (that.hasClass("swiper-initialized") ||
                    that.hasClass("slick-initialized") ||
                    (that.closest(".zfcacc-accordion").length > 0 &&
                        that.closest(".zfcacc-accordion-content-component").length > 0 &&
                        that.closest(".zfcacc-toggled").length == 0 &&
                        that.closest(".zfcacc-accordion-disabled").length == 0))
                    return;
                if (that.closest(".zfctm-media-gallery").length == 0 &&
                    that.closest(".zfctf-gallery-items").length == 0) {
                    if (zfcgac.useSwiper == false &&
                        that.data("lightbox-disabled") === undefined) {
                        var lightboxCallback = zfclightbox.create({
                            elem: that,
                            slick: true,
                            useSwiper: zfcgac.useSwiper,
                        });
                    }
                    item
                        .find(".zfcgac-gallery-count-counter")
                        .text("+ " + that.children().length + " ");
                    var txtMediaGallery = item.find(".zfcgac-gallery-button").length;
                    var gallerySwiper = zfcgac.initSlick(that, false, txtMediaGallery);
                    if (zfcgac.useSwiper &&
                        that.data("lightbox-disabled") === undefined) {
                        var lightboxCallback = zfclightbox.create({
                            elem: that,
                            clonedSlider: gallerySwiper,
                            slick: true,
                            useSwiper: zfcgac.useSwiper,
                        });
                    }
                    if (lightboxCallback) {
                        if (zfcgac.useSwiper) {
                            $(this).find(".zfcgac-lightbox-item-anchor").each(function () {
                                zfc.keyboardEnterToClick($(this));
                            });
                            $(this)
                                .find(".zfcgac-lightbox-item-anchor")
                                .off("click.zfcgac")
                                .on("click.zfcgac", function () {
                                if (item.hasClass("zfcgac-gallery-teaser")) {
                                    var selectedSlide = $(this).closest(".zfcgac-item");
                                    var prevActiveSlide = selectedSlide
                                        .parent()
                                        .find(".zfcgac-item-active");
                                    if (prevActiveSlide.length) {
                                        prevActiveSlide.removeClass("zfcgac-item-active");
                                    }
                                    selectedSlide.addClass("zfcgac-item-active");
                                }
                                lightboxCallback($(this));
                                $(".zfc-lightbox-overlay-close").focus();
                            });
                        }
                        else {
                            item
                                .find(".zfcgac-gallery-button")
                                .off("click.zfcgac")
                                .on("click.zfcgac", function () {
                                lightboxCallback($(that.find(".zfc-slider-item").first()));
                            });
                        }
                        that.find(".zfc-slider-item").each(function (index) {
                            var thatThis = $(this);
                            thatThis
                                .off("mousedown.zfcgac mousemove.zfcgac mouseup.zfcgac")
                                .on("mousedown.zfcgac", function () {
                                thatThis.isDragging = false;
                            })
                                .on("mousemove.zfcgac", function () {
                                thatThis.isDragging = true;
                            })
                                .on("mouseup.zfcgac", function () {
                                if (!thatThis.isDragging) {
                                    lightboxCallback(thatThis);
                                }
                                thatThis.isDragging = false;
                            });
                        });
                    }
                    $(that.find(".zfcgac-image-row img"))
                        .off("load.zfcgac")
                        .on("load.zfcgac", function () {
                        if ($(this).height() > $(this).width())
                            $(this).parent().addClass("zfcgac-portrait");
                    });
                }
            });
            return true;
        }
        catch (err) {
            console.log("Initalization failed: zfcgac.initItem() " + err.message);
        }
    }
    static init() {
        try {
            $(".zfcgac-gallery-alternative-component").each(function () {
                if ($(this).closest(".zfcacc-accordion-section-content").length == 0 ||
                    $(this).closest(".zfcacc-accordion-section-content").is(":visible"))
                    zfUtils.loadOnScroll($(this), "delayZFCGACLoad", zfcgac.initItem, 1);
            });
            zfc.modalCallbacks[".zfcgac-gallery-alternative-component"] =
                zfcgac.initItem;
        }
        catch (err) {
            console.log("Initalization failed: zfcgac.init() " + err.message);
        }
    }
}
zfcgac.isDragging = false;
zfcgac.currentWrapperIndex = null;
try {
    zfUtils.onReady(zfcgac.init);
}
catch (err) {
    console.log("Initalization failed: zfcgac.init() " + err.message);
}
